import { render, staticRenderFns } from "./m-menu.vue?vue&type=template&id=1e254be5&scoped=true&"
import script from "./m-menu.vue?vue&type=script&lang=js&"
export * from "./m-menu.vue?vue&type=script&lang=js&"
import style0 from "./m-menu.vue?vue&type=style&index=0&id=1e254be5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e254be5",
  null
  
)

export default component.exports